import EmbeddedLayout from '../../layouts/EmbeddedLayout';
import InitContent from '../shared/InitContent';

export default function EmbeddedAuthPage() {
  return (
    <EmbeddedLayout>
      <InitContent />
    </EmbeddedLayout>
  );
}
